'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _spacesGroup = require('./spacesGroup');

var _spacesGroup2 = _interopRequireDefault(_spacesGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = (0, _regexSupplant2.default)(/[#{spacesGroup}]/, { spacesGroup: _spacesGroup2.default });
module.exports = exports['default'];